const steps = [
  {
    num: '01',
    icon: 'ri-search-eye-line',
    title: 'İhtiyaç Analizi',
    desc: 'Mevcut durumunuzu, hedeflerinizi ve önceliklerinizi birlikte değerlendiriyoruz. Doğru soruları sorarak ihtiyacı netleştiriyoruz.',
  },
  {
    num: '02',
    icon: 'ri-file-search-line',
    title: 'Durum Değerlendirmesi',
    desc: 'Mevcut mali yapınızı, vergi yükümlülüklerinizi ve riskleri analiz ediyoruz. Eksikleri ve fırsatları raporluyoruz.',
  },
  {
    num: '03',
    icon: 'ri-settings-3-line',
    title: 'Uygulama ve Takip',
    desc: 'Belirlenen çözümleri hayata geçiriyor, yasal süreçleri yönetiyor ve tüm beyanname/bildirim takibini üstleniyoruz.',
  },
  {
    num: '04',
    icon: 'ri-customer-service-2-line',
    title: 'Sürekli Danışmanlık',
    desc: 'Değişen mevzuat ve işletme koşullarına göre sizi bilgilendiriyor, proaktif önerilerle yanınızda olmaya devam ediyoruz.',
  },
];

export default function Process() {
  return (
    <section id="surec" className="py-24 md:py-32 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-semibold tracking-widest text-[#60A5FA] uppercase">Çalışma Yöntemimiz</span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mt-3 mb-4">
            Süreç Nasıl İşler?
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto leading-relaxed">
            Şeffaf ve sistematik bir yaklaşımla, her adımda ne yapıldığını bilirsiniz.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connector line (desktop) */}
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-gray-200 z-0"></div>

          {steps.map((s, i) => (
            <div key={s.num} className="relative z-10 flex flex-col items-center text-center">
              {/* Number circle */}
              <div className="w-20 h-20 flex items-center justify-center bg-white rounded-2xl mb-6 relative">
                <span className="text-3xl font-black text-[#0A2540]/10 absolute">{s.num}</span>
                <div className="w-10 h-10 flex items-center justify-center bg-[#0A2540] rounded-xl relative z-10">
                  <i className={`${s.icon} text-white text-base`}></i>
                </div>
              </div>

              <h3 className="text-[#0A2540] font-semibold text-base mb-3">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>

              {/* Mobile connector */}
              {i < steps.length - 1 && (
                <div className="lg:hidden w-px h-8 bg-gray-200 mt-6"></div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <a
            href="#iletisim"
            onClick={(e) => { e.preventDefault(); document.querySelector('#iletisim')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#0A2540] text-white text-sm font-semibold rounded-lg hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap"
          >
            Süreci Başlatalım
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
